// Typed client for /api/medications. Mirrors the shared.Medication shape.

import type { Medication } from '@medreview/shared';
import type { AuthedFetch } from '../hooks/useAuthedFetch';

interface MedicationsListResponse {
  ok: true;
  data: {
    items: Medication[];
    nextCursor: string | null;
    hasMore: boolean;
  };
}

interface ApiErrorResponse {
  ok: false;
  error: { code: string; message: string };
}

type ApiResponse<T> = T | ApiErrorResponse;

export async function listMedications(authedFetch: AuthedFetch): Promise<Medication[]> {
  const res = await authedFetch('/api/medications');
  const body = (await res.json()) as ApiResponse<MedicationsListResponse>;
  if (!body.ok) {
    throw new Error(`${body.error.code}: ${body.error.message}`);
  }
  return body.data.items;
}
